module.exports = __webpack_public_path__ + "img/company_logo.456c0a9f.png";